<template>
  <div>
    <!-- 点击阅读同意弹出 -->
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="true"
      @close="closeDialog"
      custom-class="dialog_normal"
      :append-to-body="true"
    >
      <div class="detail_cont">
        <div class="flex_center">
          <img
            style="width: 60px"
            src="@/assets/dialogIcoImg/RiskScantwo.png"
            alt=""
          />
        </div>
        <ul class="detail_cont_text">
          <li class="risk-li margin-bottom10">
            <p class="flex_center_bettwen">
              <span class="risk-li-title"
                >1.&nbsp; Add companies from Search Result</span
              >
              <button
                class="btn_export"
                style="min-height: 40px !important"
                @click="goHome()"
              >
                Choose
              </button>
            </p>
            <!-- <p>You can select companies that interest you in the system for risk scanning</p> -->
          </li>
          <li class="risk-li margin-bottom10">
            <p class="flex_center_bettwen">
              <span class="risk-li-title"
                >2.&nbsp;Add companies from My Database</span
              >
              <button
                class="btn_export"
                style="min-height: 40px !important"
                @click="gotoUSer('/account/companiesViewed')"
              >
                Choose
              </button>
            </p>
            <!-- <p>You can select companies that interest you in the system for risk scanning</p> -->
          </li>
          <li class="risk-li margin-bottom10">
            <p class="flex_center_bettwen">
              <span class="risk-li-title"
                >3.&nbsp;Add companies by upload my own list</span
              >
              <button
                class="btn_export"
                style="min-height: 40px !important"
                @click="UploadFileList()"
              >
                Upload
              </button>
            </p>
            <!-- <p>You can select companies that interest you in the system for risk scanning</p> -->
          </li>
          <li class="risk-li margin-bottom10">
            <p class="flex_center_bettwen">
              <span class="risk-li-title">4.&nbsp;Updated data</span>
              <button
                :class="!updateDowin ? 'btn_exporthui' : 'btn_export btnbox'"
                :disabled="!updateDowin"
                class="btn_export"
                @click="getUpdate()"
                style="min-height: 40px !important"
              >
                View
              </button>
            </p>
            <!-- <p>You can select companies that interest you in the system for risk scanning</p> -->
          </li>
        </ul>
      </div>
    </el-dialog>
    <UpdateFile
      :UpdateFileDialog="UpdateFileDialog"
      :isUploaded="isUploaded"
      @closeUpDownDialog="closeUpDownDia"
    ></UpdateFile>
  </div>
</template>
<script>
import crypto from "@/utils/crypto";
import UpdateFile from "../../views/myAccount/Database/adCppany/UpdateFile.vue";
export default {
  props: {
    showReport: {
      type: Boolean,
      default: false,
    },
    powerStatus: {
      type: Boolean,
      default: false,
    },
    updateDowin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UpdateFile,
  },
  data() {
    return {
      // newDialog: true,
      UpdateFileDialog: false,
      finDialog: false,
      isUploaded: false,
      reportDialog: false,
      newDialogtwo: false,

      filesList: [],
      disabledReport1: true,
      disabledReport2: true,
      disabledReport: true,
      checked: false,
    };
  },
  computed: {
    newDialog: {
      get() {
        return this.showReport;
      },
      set(newValue) {},
    },
  },
  created() {},
  methods: {
    closeUpDownDia(val) {
      this.UpdateFileDialog = val;
    },
    UploadFileList() {
      this.UpdateFileDialog = true;
    },
    // 上传弹框
    closeUpDownDia(val) {
      this.UpdateFileDialog = val;
    },
    gotoUSer(value) {
      //  this.$router.go(0)
      this.$router.push({
        path: value,
        query: {
          type: 4,
        },
      });
      this.closeDialog();
    },
    getUpdate() {
      this.$parent.reportDialog = false;
      this.$parent.getgetUserConsumptionPageList(true);
    },
    goHome() {
      this.newDialogtwo = false;
      this.$router.push("/");
      this.closeDialog();
      this.$parent.newDialog = false;
    },
    closeDialog() {
      this.$emit("closeReportDialog", false);
    },
  },
};
</script>
<style scoped>
.btn_export {
  border-radius: 0.7142857142857143rem;
  height: auto;
}

.dialog_lg.el-dialog {
  width: 1150px;
  /* max-height: 85vh; */
  background: #ffffff;
}

.detail_cont_text {
  /* 解决英文截断问题 */
  word-break: keep-all;
  text-align: justify;
  font-size: 1.285714285714286rem;
  color: #1a2332;
  line-height: 30px;
  padding-top: 20px;
}

.dialog_detail_title {
  font-size: 20px;
  color: #1a2332;
  /* line-height: 27px; */
  /* line-height: 40px; */
  margin-bottom: 20px;
  font-family: "Arial Bold";
}
.risk-li {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 1.4285714285714286rem;
}
.risk-li-title {
  font-size: 1.42857143rem;
  color: #1a2332;

  font-family: "Arial Bold";
}
</style>
